import { searchProductsWithMetricsDataParams } from './params/search-products-with-metric-data-params'
import { productsFields } from './fragments/products-fields'
import { filtersVariables } from './variables/filters-variables'
import { metricDataVariables } from './variables/metric-data-variables'

export const querySearchFeaturedStores = /* GraphQL */ `
  query searchFeaturedStores(
    $term: String!,
    ${filtersVariables},
    ${metricDataVariables}
  ) {
      featured_stores_search(products: ${searchProductsWithMetricsDataParams}) {
        stores {
          id
          name
          path
          avatar {
            image_public_id
          }
          products {
            ...productsFields
          }
        }
      } 
    }

  ${productsFields}
`
